import { render, staticRenderFns } from "./ResponsiveMobile.vue?vue&type=template&id=2b46296d"
import script from "./ResponsiveMobile.vue?vue&type=script&lang=js"
export * from "./ResponsiveMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports